import { useRouter } from 'next/router';
import { getRouterLocale } from '../i18Utils/constant';
import { one_dirham_multipler, weightloss_uae } from './constants';

export const uaeString = 'uae';

export const convertPrice = (price, addDecimal) => {
  if (typeof price === 'string' && price.includes('₹')) {
    const res = price.split('₹')[1];
    const rk = convertPrice(parseInt(res));
    return rk;
  } else {
    if (typeof window != 'undefined') {
      const country = getCountry();
      const symbol = getSymbol(country);
      const updatedPrice = getPrice(country, price, addDecimal);
      return { symbol, price: updatedPrice };
    }
    const symbol = getSymbol();
    return { symbol, price };
  }
};
export const getCountry = () => {
  if (typeof window != 'undefined') {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('country');
  }
};
export const getPrice = (country, price, addDecimal) => {
  switch (country) {
    case uaeString:
      return parseFloat((price * one_dirham_multipler).toFixed(2));
    case 'in':
      return price + (addDecimal ? '.00' : 0);
    default:
      return price + (addDecimal ? '.00' : 0);
  }
};
export const getSymbol = (country) => {
  switch (country) {
    case uaeString:
      return 'AED ';
    case 'in':
      return '₹';
    default:
      return '₹';
  }
};

//export const isUAE = getCountry() === uaeString;
export const changeRouterOnCountry = (country, router) => {
  switch (country) {
    case 'uae':
      router.push('/store/address' + window.location.search, '', {
        locale: getRouterLocale(router),
      });
    default:
      return;
  }
};

export const getCountryCode = () => {
  const country = getCountry();
  switch (country) {
    case uaeString:
      return 'UAE';
    case 'in':
      return 'IND';
    default:
      return 'IND';
  }
};
export const getSymbolForCountry = () => {
  const router = useRouter();
  const path = router.asPath;
  switch (true) {
    case path.includes('/uae/'):
      return 'AED';
    default:
      return '₹';
  }
};
export const getCountryOnBasisOfUrl = () => {
  const router = useRouter();
  const path = router.asPath;
  switch (true) {
    case path.includes('/uae/'):
      return 'UAE';
    default:
      return 'IND';
  }
};
export const getCountryCodeOnBasisOfUrl = () => {
  const router = useRouter();
  const path = router.asPath;
  switch (true) {
    case path.includes('/uae/'):
      return '+971';
    default:
      return '+91';
  }
};

export function replaceDataWithCustom(clinicData) {
  const clinicListingData = JSON.parse(JSON.stringify(clinicData));
  let indexRemove = -1;
  clinicListingData?.data?.cards?.map((card, index) => {
    if (card._id === '13') indexRemove = index;

    if (card.itemType === 'PDP_VARIANT_OPTIONS')
      clinicListingData.data.cards[index] = weightloss_uae;
  });
  if (indexRemove != -1) {
    clinicListingData.data.cards.splice(indexRemove, 1);
  }
  if (clinicListingData.data.bottomCtas)
    clinicListingData.data.bottomCtas.stickyCta.text = 'Book Now';
  return clinicListingData;
}
